import(/* webpackMode: "eager" */ "/app/src/app/(app)/auth/forgot-password/page.tsx");
